import SuperModal from './SuperModal';

export default SuperModal;

export { default as ModalContent } from './ModalContent';
export { default as ModalHeader } from './ModalHeader';
export { default as ModalHeaderGroup } from './ModalHeaderGroup';
